// extracted by mini-css-extract-plugin
module.exports = {"sliderBlock":"Tabs_sliderBlock__3HOIH","sliderItem":"Tabs_sliderItem__1WGYn","icon":"Tabs_icon__2lMZs","active":"Tabs_active__2dVhy"};